<template lang="pug">
  div.overlay
    Spinner.loader(
      :size="100"
      color="white"
    )
</template>

<script>
import Spinner from 'vue-spinner-component/src/Spinner'

export default {
  name: 'LoaderOverlay',
  components: { Spinner },
}
</script>

<style lang="scss" >
.overlay {
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.loader {
  position: fixed;
  top: 45%;
  left: 45%;
  transform: translate(-70%, -50%);
  border-color: rgba(0, 0, 0, 0);
}
</style>
